/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import "./cycleVisualizer.scss";

const CycleVisualizer = ({ startDate, interrogations, cycle = 30, rMonitoringCycles }) => {
  const irStatus = (status) => {
    switch (status) {
      case "TERMINATED":
        return "R";
      case "PRELIMINARY":
        return "P";
      case "FINAL":
        return "F";
      default:
        return "-";
    }
  };

  let interrogationsArray = [];
  if (rMonitoringCycles) {
    rMonitoringCycles.map((item) => {
      interrogations.forEach((ir) => {
        const beginning = new Date(item.startDayOFServiceWindow).getTime();
        const end = new Date(item.endDayOFServiceWindow).getTime();
        if (beginning <= ir.interrogationDate && end > ir.interrogationDate) {
          let status = irStatus(ir.interrogationStatus);
          interrogationsArray.push([ir.id, ir.interrogationDate, status]);
        }
      });
    });
  }
  const checkStartDate = (start, end) => {
    const startValue = new Date(start).getTime();
    const endValue = new Date(end);
    endValue.setHours(endValue.getHours() + 23);
    endValue.setMinutes(endValue.getMinutes() + 59);
    endValue.setSeconds(endValue.getSeconds() + 59);
    const endValueSeconds = endValue.getTime();
    const today = new Date().getTime();
    if (startValue <= today && endValueSeconds > today) {
      let point = today - startValue;
      let pastDays = parseInt(point / 1000 / 60 / 60 / 24, 10);
      let position;
      if (cycle == 30) {
        position = (pastDays * 100) / 30;
      }
      if (cycle == 90) {
        position = (pastDays * 100) / 90;
      }
      return position;
    }
    return null;
  };

  if (startDate && rMonitoringCycles) {
    const checkInterrogation = (start, end, date, id, status) => {
      let response;
      let position;
      const first = new Date(start).getTime();
      const last = new Date(end);
      last.setHours(last.getHours() + 23);
      last.setMinutes(last.getMinutes() + 59);
      last.setSeconds(last.getSeconds() + 59);
      const lastSeconds = last.getTime();
      if (first <= date && date < lastSeconds) {
        let point = date - first;
        let daysLeft = parseInt(point / 1000 / 60 / 60 / 24, 10);
        if (cycle == 30) {
          position = (daysLeft * 100) / 30;
        }
        if (cycle == 90) {
          position = (daysLeft * 100) / 90;
        }
        response = `
          <div class="interrogation-point" style="left:${position}%">
            <a href=/dashboard3/${id}>
              <div
                class="interrogation-status"
              >
                ${status}
              </div>
            </a>
          </div>
        `;
      }
      return { __html: response };
    };

    return (
      <>
        <h3>{cycle}-Day Cycle</h3>
        <div className="cycle cycle-30-days">
          <div className="cycle-content">
            {rMonitoringCycles &&
              rMonitoringCycles.map((item, index) => (
                <div
                  className="cycle-window"
                  key={index}
                  style={{
                    width: cycle == 30 ? "8.33%" : "25%",
                  }}
                >
                  {checkStartDate(item.startDayOFServiceWindow, item.endDayOFServiceWindow) && (
                    <div
                      className="start-date-indicator"
                      style={{
                        left: `${checkStartDate(item.startDayOFServiceWindow, item.endDayOFServiceWindow)}%`,
                      }}
                    ></div>
                  )}
                  {interrogationsArray &&
                    interrogationsArray.map((ir, index) => {
                      return (
                        <div
                          key={index}
                          className="interrogation-indicator"
                          dangerouslySetInnerHTML={checkInterrogation(
                            item.startDayOFServiceWindow,
                            item.endDayOFServiceWindow,
                            ir[1],
                            ir[0],
                            ir[2]
                          )}
                        />
                      );
                    })}
                  <div className="blackout-period"></div>
                  <div key={index} className="billing-cycle">
                    <p
                      className="dates-display"
                      style={{
                        fontSize: cycle == 30 ? "10px" : "11px",
                        height: cycle == 30 ? "30%" : "15px",
                      }}
                    >
                      {`${item?.startDayOFBillingPeriod[0]}/${item?.startDayOFBillingPeriod[1]}/${item?.startDayOFBillingPeriod[2]}`}
                      -
                      {`
                    ${item?.endDayOFBillingPeriod[0]}/${item?.endDayOFBillingPeriod[1]}/${item?.endDayOFBillingPeriod[2]}`}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </>
    );
  }
  return null;
};

export default CycleVisualizer;
